// extracted by mini-css-extract-plugin
module.exports = {"list":"homeseller_list__bx8KV"};